import { render } from "./EditLogo.vue?vue&type=template&id=429e62f2"
import script from "./EditLogo.vue?vue&type=script&lang=js"
export * from "./EditLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__